/* eslint-disable */
/**
 * MetaDataService.js contains all of the service functions used for the overall
 * configuration meta data.
 *
 * @endpoints /metaData/:
 * 		initialDecisionRetrieve - retrieve meta data for an initial decision
 * 		factorRetrieve - retrieve meta data for an evaluation factor
 * 		initialDecisionUpdate - update meta data for an initial decision
 * 		factorUpdate - update meta data for a factor
 *
 * @author Sophia Frankel <sophia.frankel@quavo.com>
 */
import API from '@/services/APIService';

export default {
	name: 'MetaDataService',
	/**
	 * Retrive an initial decision's meta data based on the provided payload
	 * @param {Object} payload - initial decision object containing request body parameters
	 * @param {*} dispatch - dispatch a notification in the event of an error
	 * @returns an object containing initial decision meta data
	 */
	retrieveInitialDecision(payload, dispatch) {
		return API.call('/metaData/initialDecisionRetrieve', {
			tenantId: payload.tenantId,
			initialDecisionConfigId: payload.initialDecisionConfigId
		}).catch(error => {
			dispatch("notifications/addNotification", {
				status: 'error',
				message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
			});
		});
	},
	/**
	 * Retrive an evaluation factor's meta data based on the provided payload
	 * @param {Object} payload - evaluation factor object containing request body parameters
	 * @param {*} dispatch - dispatch a notification in the event of an error
	 * @returns an object containing evaluation factor meta data
	 */
	retrieveFactor(payload, dispatch) {
		return API.call('/metaData/factorRetrieve', {
			tenantId: payload.tenantId,
			factorId: payload.factorId
		}).catch(error => {
			dispatch("notifications/addNotification", {
				status: 'error',
				message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
			});
		});
	},
	/**
	 * Update an initial decision's meta data based on the provided payload
	 * @param {Object} decision - initial decision object containing request body parameters
	 * @param {*} dispatch - dispatch a notification in the event of an error
	 * @returns a status message
	 */
	updateInitialDecision(decision, dispatch) {
		return API.call('/metaData/initialDecisionUpdate', {
			tenantId: decision.tenantId,
			rightSideType: decision.rightSideType,
			leftSideValue: decision.leftSideValue,
			operatorOptions: decision.operatorOptions,
			rightSideOptions: decision.rightSideOptions,
			leftSideType: decision.leftSideType,
			initialDecisionConfigId: decision.initialDecisionConfigId,
			label: decision.label,
			isActive: decision.isActive
		}).catch(error => {
			dispatch("notifications/addNotification", {
				status: 'error',
				message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
			});
		});
	},
	/**
	 * Update an evaluation factor's meta data based on the provided payload
	 * @param {Object} factor - evaluation factor object containing request body parameters
	 * @param {*} dispatch - dispatch a notification in the event of an error
	 * @returns a status message
	 */
	updateFactor(factor, dispatch) {
		return API.call('/metaData/factorUpdate', {
			tenantId: factor.tenantId,
			category: factor.category,
			description: factor.description,
			factorId: factor.factorId,
			functionName: factor.functionName,
			isActive: factor.isActive,
			knowledgeBaseUrl: factor.knowledgeBaseUrl,
			label: factor.label,
			scope: factor.scope,
			thresholds: factor.thresholds,
			treeMode: factor.treeMode,
			type: factor.type,
			whyItWorks: factor.whyItWorks
		}).catch(error => {
			dispatch("notifications/addNotification", {
				status: 'error',
				message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
			});
		});
	}
};